import { EtcChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreEtc } from '@types';

const initialState: IStoreEtc = {
  [EtcChildOptionValueEnum.오브젝트]: true,
  [EtcChildOptionValueEnum.인외존재]: true
};

export const etcSlice = createSlice({
  name: 'etc',
  initialState,
  reducers: {
    initEtc: () => {
      return initialState;
    },

    setEtc: (state, action: PayloadAction<IStoreEtc>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initEtc, setEtc } = etcSlice.actions;

export default etcSlice.reducer;
